document.addEventListener("DOMContentLoaded", function () {

    const emblaNode = document.querySelector(".embla");

    if (!emblaNode) return;

    const embla = EmblaCarousel(emblaNode, {
        loop: true,
        align: "start",
        dragFree: true
    });

    const prev = document.querySelector(".emm-prev");
const next = document.querySelector(".emm-next");

prev.addEventListener("click", () => embla.scrollPrev());
next.addEventListener("click", () => embla.scrollNext());

    let timer = setInterval(function () {
        embla.scrollNext();
    }, 5000);

    emblaNode.addEventListener("mouseenter", function () {
        clearInterval(timer);
    });

    emblaNode.addEventListener("mouseleave", function () {

        timer = setInterval(function () {
            embla.scrollNext();
        }, 5000);

    });

});